module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image1_bg-0bd0a6e1b318ead11eb9901f9c32ddad.png";